<div class="expired">
  <div class="dark-blue">
    <nestas-toolbar [steps]="[]"></nestas-toolbar>
  </div>

  <mat-card align="center" *ngIf="success">
    <div class="mat-card-wrapper">
      <div mat-card-image>
        <i class="material-icons green ic-error">check_circle</i>
      </div>
      <mat-card-title>{{translate.instant('EXPIRED.EXTEND.SUCCESS.TITLE')}}</mat-card-title>
      <mat-card-subtitle>{{translate.instant('EXPIRED.EXTEND.SUCCESS.MESSAGE')}}</mat-card-subtitle>
      <button mat-raised-button (click)="done()" color="primary" class="confirm-btn cursor">
        {{translate.instant('EXPIRED.EXTEND.SUCCESS.BUTTON')}}
      </button>
    </div>
  </mat-card>

  <mat-card align="center" *ngIf="!success">
    <div class="mat-card-wrapper">
      <div mat-card-image>
        <i class="material-icons red ic-error">error</i>
      </div>
      <mat-card-title>{{translate.instant('EXPIRED.TITLE')}}</mat-card-title>
      <mat-card-subtitle>
        {{translate.instant('EXPIRED.MESSAGE_1')}}
        <a href="{{translate.instant('TOOLBAR.NESTAS_PRICE_LINK')}}"><br><br>
          <button mat-raised-button color="primary" class="confirm-btn cursor">
            {{translate.instant('EXPIRED.MESSAGE_2')}}
          </button>
        </a>
      </mat-card-subtitle>
      <mat-card-content *ngIf="canExtend()">
        <div class="alert-info" style="display:inline-block;">
          {{translate.instant('EXPIRED.EXTEND.MESSAGE')}}<br/><br/>
          <button mat-raised-button (click)="extendTrial()">{{translate.instant('EXPIRED.EXTEND.BUTTON')}}</button>
        </div>
      </mat-card-content>

      <br/>
      <mat-card-title>Contact info</mat-card-title>
      <contact></contact>
    </div>
  </mat-card>
</div>
